import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiArrowLeft } from 'react-icons/fi';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    if (user) {
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="privacy-page">
      <div className="privacy-header-container">
        <button className="privacy-back-btn" onClick={handleBack}>
          <FiArrowLeft /> {user ? 'Back to Profile' : 'Back to Login'}
        </button>
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-subtitle">Last updated: June 9, 2026</p>
      </div>

      <div className="privacy-card">
        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to <strong>Shubham Computers (Shubink)</strong>. We value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our mobile application and web services. This policy should be read in conjunction with our <span className="privacy-link" style={{ cursor: 'pointer' }} onClick={() => navigate('/terms')}>Terms & Conditions</span>.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <ul>
            <li>
              <strong>Personal Information:</strong> We collect your name, phone number, and password when you register or login to create a secure account and manage your orders.
            </li>
            <li>
              <strong>File Uploads & Documents:</strong> To provide print-on-demand services, you upload PDF, Word, Excel, and image documents. These files are processed securely and deleted shortly after order completion. We do not inspect, share, or store your documents beyond fulfilling your printing request.
            </li>
            <li>
              <strong>Location Data:</strong> With your permission, we collect precise GPS coordinates to verify that your delivery address lies within our strict 3km geofence radius centered on our physical store in Jhajjar.
            </li>
            <li>
              <strong>Store Credit & Payments:</strong> We track your store credit balance and transaction history to manage refunds, adjustments, and order payments.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected data for the following specific purposes:</p>
          <ul>
            <li>To process, format, print, and deliver your orders within Jhajjar.</li>
            <li>To confirm that your physical delivery requests fall within our 3km service area.</li>
            <li>To facilitate store credit usage and authorize secure transactions.</li>
            <li>To provide personalized assistance through our integrated AI helper chatbot.</li>
            <li>To send OTP messages for secure account creation, password resets, and verification.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Data Retention & Deletion</h2>
          <p>
            Your account credentials, store credit status, and order history are stored securely as long as your account is active. **Uploaded documents are treated with the highest confidentiality and are automatically purged from our cloud storage buffers immediately after the physical print job is successfully completed by our staff.**
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Data Security</h2>
          <p>
            We implement robust administrative, technical, and physical security measures, including HTTPS encryption and secure database structures, to safeguard your personal data and uploaded documents against unauthorized access, loss, or alteration.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Third-Party Services</h2>
          <p>
            We partner with reliable third-party providers solely to facilitate our core operations:
          </p>
          <ul>
            <li><strong>Razorpay:</strong> To process secure payment gateway integrations for direct payments and store credit adjustments.</li>
            <li><strong>2Factor:</strong> To transmit secure OTP verification codes and account authentication via SMS and automated voice verification calls.</li>
            <li><strong>Cloudinary:</strong> For secure, temporary storage of document uploads before printing.</li>
          </ul>
          <p>These third parties are strictly bound to protect your data and only access it to perform their designated tasks.</p>
        </section>

        <section className="privacy-section">
          <h2>7. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact us at:
          </p>
          <div className="privacy-contact-details" style={{ lineHeight: '1.6' }}>
            <strong>Shubham Computers (Shubink)</strong><br />
            Opposite Gujjar Dharmshala, Near Govt. Girls Senior Secondary School, Adarsh Nagar, Jhajjar, Haryana - 124103, India<br />
            <a 
              href="https://maps.google.com/?q=28.605441,76.653198" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: 'var(--primary-light)', display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4, marginBottom: 6, textDecoration: 'none', fontWeight: '600' }}
            >
              📍 View Store Location on Google Maps
            </a><br />
            Email: <a href="mailto:shubhamcybercafe001@gmail.com" style={{ color: 'var(--primary-light)' }}>shubhamcybercafe001@gmail.com</a><br />
            Phone: <a href="tel:+919350336367" style={{ color: 'var(--primary-light)' }}>+91 93503 36367</a>
          </div>
        </section>
      </div>
      <div className="fab-spacer"></div>
    </div>
  );
};

export default PrivacyPolicy;
